import z from 'zod'
import { Model } from '../../_kernel/architecture'

export type BedTypes = (typeof AVAILABLE_BED_TYPES)[number]
export const AVAILABLE_BED_TYPES = [
  'FullBed',
  'QueenBed',
  'KingBed',
  'MurphyBed',
  'WaterBed',
  'TwinBed',
  'TwinXLBed',
  'SofaBed',
  'FutonBed',
  'BunkBed',
  'TrundleBed',
] as const

const BedTypeValidation = z.object({
  value: z.enum(AVAILABLE_BED_TYPES, { message: '[BedType] Invalid bed type' }),
})

export class BedType extends Model {
  static create({ value }: { value: BedTypes }) {
    BedTypeValidation.parse({ value })
    return new BedType(value)
  }

  constructor(private readonly _value: BedTypes) {
    super()
  }

  value() {
    return this._value
  }
}
